export const QueryKeys = {
  AuditEvents: 'list/auditEvents',
  AuditEventsUsers: 'list/auditEventsUsers',
  AuditEventsIntegrations: 'list/auditEventsIntegrations',
  AuditEventTypes: 'list/auditEventTypes',
};
